<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <div id="background-home"></div>
    <div id="ball-home"></div>
    <img id="background-grass" src="@/assets/practices/soccer_goal/home_grass.svg" alt="grass" />
    <div class="content">
      <div class="title">Soccer Goal!</div>
      <div class="subtitle">Greater & Less Than</div>
      <button @click="clickInstructions">Instructions</button>
    </div>
    <div v-show="instructionsStatus" class="instructions">
      <div class="instructions__container">
        <div class="border">
          <h3>You will learn about the greater and less than symbols!</h3>
          <p>Click on the ball to choose the correct symbol for the exercises. Good luck!</p>
          <button @click="clickStart">Start</button>
          <img id="dotted-line-top" src="@/assets/practices/soccer_goal/dotted_line.svg" alt="dotted-line" />
          <img id="dotted-line-bottom" src="@/assets/practices/soccer_goal/dotted_line.svg" alt="dotted-line" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import lottie from 'lottie-web/build/player/lottie';
// import { Howl } from 'howler';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  data: () => ({
    instructionsStatus: false,
  }),
  computed: {
    ...mapGetters({ homeScreenStatus: 'soccerGoal/homeScreenStatus' }),
  },
  mounted() {
    const backgroundHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('background-home'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/soccer_goal/animations/soccer_goal_home_background.json',
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });
    backgroundHomeAnimation.play();
    const ballHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('ball-home'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/soccer_goal/animations/soccer_goal_home_ball.json',
    });
    ballHomeAnimation.play();
  },
  methods: {
    ...mapActions({ homeClickStart: 'soccerGoal/homeClickStart' }),
    clickInstructions() {
      sounds.globalButton.play();
      this.instructionsStatus = true;
    },
    clickStart() {
      sounds.soccerGoalButtonStart.play();
      this.homeClickStart();
      this.instructionsStatus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;
  height: 100vh;
  position: absolute;
  width: 100vw;
  background-color: #73b8e0;
}

.content {
  bottom: 10vh;
  position: absolute;
  right: 10vw;
  text-align: center;
  z-index: 1;

  * {
    margin: 0.15em 0;
  }

  .title {
    font-size: 2em;
  }

  .subtitle {
    font-size: 1.25em;
  }
}

.instructions {
  @include flex-center;
  background-color: green;
  background-image: url('~@/assets/practices/soccer_goal/instructions_background.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  position: absolute;
  width: 100vw;
  z-index: 1;

  &__container {
    @include flex-center;
    background-color: $soccer-goal-color-main;
    padding: 0.25em 0;
    width: 100vw;

    .border {
      @include flex-center;
      // border: 10px dotted $soccer-goal-color-text;
      flex-direction: column;
      height: 60%;
      margin: unset;
      padding: 1em 0;
      position: relative;
      width: 120%;

      * {
        margin: 0.5em;
      }

      h3,
      p {
        text-align: center;
        width: 80%;
      }

      #dotted-line-top,
      #dotted-line-bottom {
        position: absolute;
        width: 130vw;
      }

      #dotted-line-top {
        top: -10px;
      }

      #dotted-line-bottom {
        bottom: -10px;
      }
    }
  }
}

button {
  background-color: $soccer-goal-color-text;
  border: none;
  //   border: 3px solid #707070;
  border-radius: 50vh;
  color: $soccer-goal-color-main;
  font-size: 1.25em;
  padding: 0.15em 0.75em;
}

#background-home,
#background-grass,
#ball-home {
  position: absolute;
}

#background-home {
  height: 100vh;
  width: 100vw;
}

// Has some responsivity issues.
#background-grass {
  width: 100vw;
  top: 40vh;
}

#ball-home {
  $ball-size: 140vh;

  // bottom: -5vh;
  height: $ball-size;
  // transform: translate(-15vw, 0);
  width: $ball-size;
  z-index: 1;
}
</style>
